module.exports = __webpack_public_path__ + "img/mini.435c5759.png";